import styled, { css } from 'styled-components';
import { bottonCommon } from './CssCommon';

const FileButtonContainer = styled.button`
  ${bottonCommon}

  ${({ primary }) =>
    primary &&
    css`
      background: #1d7ff9;
      color: #fff;
      border: none;
      &:hover {
        background: #4b9afc;
      }
      &:active {
        background: #0b65d4;
      }
    `}

  ${({ cssExt }) => cssExt && cssExt}
`;

const FileBtnLabel = styled.label`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  cursor: pointer;
`;

function FileButton({ children, onChange, onClick, acceptExt, cssExt, block, primary }) {
  const onClickInner = () => {
    // alert('inner');
    //GA자리 !!
    if (onClick) onClick();
  };

  return (
    <FileButtonContainer cssExt={cssExt} block={block} primary={primary}>
      <FileBtnLabel htmlFor="__file-open" onClick={onClickInner}>
        {children}
      </FileBtnLabel>
      <input id="__file-open" type="file" hidden accept={acceptExt} onChange={onChange} />
    </FileButtonContainer>
  );
}

export default FileButton;
